module.exports = __webpack_public_path__ + "img/terry-executive-education-center.6776da76.jpg";